<ng-container *ngIf="!loading">
    <ng-container *ngIf="!error">
        <div class="container my-5">
            <ng-container *ngIf="consentData!.status === GrdfAccessRightStatus.ACTIVE">
                <div class="alert alert-success">
                    <h2>Votre consentement est déjà enregistré ✅</h2>
                    <p class="mb-0">Vous avez déjà donné votre accord au partage de vos données.</p>
                </div>
            </ng-container>

            <ng-container
                *ngIf="
                    consentData!.status === GrdfAccessRightStatus.PENDING_VALIDATION &&
                    !consentData!.consentStart
                ">
                <div class="card p-4 shadow-sm">
                    <h2 class="mb-3">
                        Consentement au partage de vos données de consommation GRDF
                    </h2>

                    <p>
                        Je,
                        <span *ngIf="clientIdentity"
                            ><strong>{{ clientIdentity }}</strong></span
                        >, déclare être dûment habilité
                        <span *ngIf="clientSociety"
                            >par <strong>{{ clientSociety }}</strong></span
                        >
                        pour autoriser <strong>{{ consentData!.organization }}</strong
                        >, par le biais de son prestataire
                        <strong>{{ consentData!.grdfClientName | uppercase }}</strong
                        >, à accéder aux données du compteur n°<strong>{{
                            consentData!.pdlNumber
                        }}</strong
                        >.
                    </p>

                    <p>
                        Cette autorisation est valable pour les données publiées entre
                        <strong>{{
                            consentData!.consumptionAccessStart | date: 'dd/MM/yyyy'
                        }}</strong>
                        et <strong>{{ consentData!.validUntil | date: 'dd/MM/yyyy' }}</strong
                        >.
                    </p>

                    <p>
                        J'autorise <strong>{{ consentData!.organization }}</strong> à récupérer les
                        informations suivantes :
                    </p>

                    <form [formGroup]="consentForm">
                        <div class="form-check mb-2">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                formControlName="dataConsumption"
                                id="dataConsumption" />
                            <label class="form-check-label" for="dataConsumption">
                                Données de consommation
                            </label>
                        </div>
                        <div class="form-check mb-2">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                formControlName="profileData"
                                id="profileData" />
                            <label class="form-check-label" for="profileData">
                                Données de profil
                            </label>
                        </div>
                        <div class="form-check mb-3">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                formControlName="technicalData"
                                id="technicalData" />
                            <label class="form-check-label" for="technicalData">
                                Données techniques
                            </label>
                        </div>
                    </form>

                    <p class="text-muted small">
                        Cet accès est encadré par Grdf et conforme à la réglementation en vigueur,
                        notamment le RGPD. Votre consentement est libre, limité dans le temps, et
                        peut être révoqué à tout moment sur votre espace GRDF.
                    </p>
                    <p class="text-muted small">
                        Après votre validation, GRDF vous adressera un e-mail, et parfois un SMS,
                        afin de confirmer définitivement votre consentement. Cette étape est
                        obligatoire pour que l’accès soit effectif.
                    </p>

                    <p class="text-muted small">
                        Sans votre accord, aucune donnée ne sera collectée ni transmise.
                    </p>

                    <div class="mt-3">
                        <ng-container *ngIf="!consentGiven; else acceptedBlock">
                            <div class="d-flex gap-2">
                                <ed-button [disabled]="consentForm.invalid" (click)="onAccept()">
                                    Valider le consentement
                                </ed-button>

                                <ed-button
                                    [colorSchema]="buttonColors.Secondary"
                                    (click)="onRevoke()"
                                    >Refuser</ed-button
                                >
                            </div>
                        </ng-container>

                        <ng-template #acceptedBlock>
                            <div class="alert alert-success mb-0">
                                Votre accord a bien été pris en compte ✅
                                <p>
                                    Conformément à la procédure GRDF, un e-mail (et éventuellement
                                    un SMS) vous sera envoyé afin de confirmer définitivement votre
                                    consentement. Cette étape est nécessaire pour que nous puissions
                                    accéder à vos données de consommation
                                </p>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </ng-container>

            <ng-container
                *ngIf="
                    consentData!.status === GrdfAccessRightStatus.PENDING_VALIDATION &&
                    consentData!.consentStart
                ">
                <div class="alert alert-success">
                    <h2>Vous avez déjà accepté le consentement ✅</h2>
                    <p class="mb-0">
                        Conformément à la procédure GRDF, un e-mail (et éventuellement un SMS) vous
                        sera envoyé afin de confirmer définitivement votre consentement. Cette étape
                        est nécessaire pour que nous puissions accéder à vos données de consommation
                    </p>
                </div>
            </ng-container>

            <ng-container *ngIf="consentData!.status === GrdfAccessRightStatus.REVOKED">
                <div class="alert alert-warning">
                    <h2>Vous avez déjà refusé le consentement ❌</h2>
                    <p class="mb-0">Vous ne pouvez plus l’accepter.</p>
                </div>
            </ng-container>

            <ng-container
                *ngIf="
                    consentData!.status === GrdfAccessRightStatus.DISABLED ||
                    consentData!.status === GrdfAccessRightStatus.OBSOLETE ||
                    consentData!.status === GrdfAccessRightStatus.REFUSED ||
                    consentData!.status === GrdfAccessRightStatus.CHECK_AGAIN ||
                    consentData!.status === GrdfAccessRightStatus.UNKNOW
                ">
                <div class="alert alert-danger">
                    <h2>Lien de consentement invalide ou expiré ❌</h2>
                    <p class="mb-0">
                        Le lien que vous avez utilisé n’est plus valide. Veuillez contacter
                        l’administrateur.
                    </p>
                </div>
            </ng-container>
        </div>
    </ng-container>

    <ng-container *ngIf="!!error">
        <div class="container my-5">
            <div class="alert alert-danger">
                <h2>Lien de consentement invalide ou expiré ❌</h2>
                <p class="mb-0">
                    Le lien que vous avez utilisé n’est plus valide. Veuillez contacter
                    l’administrateur.
                </p>
            </div>
        </div>
    </ng-container>
</ng-container>
